module.exports = __webpack_public_path__ + "img/组 3.68a4a1de.webp";